export interface Block {
  label?: string;
  count?: number;
  buttonText?: string;
  onButtonClick?: () => void;
}

export interface SummaryBlockProps {
  blocks: Block[];
  title?: string;
  className?: string;
  variant?: string;
  tooltipText?: string;
}

export enum SummaryBlockVariants {
  'Grey' = 'grey',
  'Orange' = 'orange',
  'LightBlue' = 'lightBlue',
  'DarkBlue' = 'darkBlue',
  'Green' = 'green',
  'Red' = 'red',
}
